// extracted by mini-css-extract-plugin
export default {"headerHighlight":"style_headerHighlight__yNpKu"};